module.exports = __webpack_public_path__ + "img/manage-board-logo.68c714fc.png";